const initDisplay = () => {
    $('.bread-crumb').addClass('no-bread');
};

export {
    initDisplay
};
